import {defineStore} from "pinia";

import AxiosClass from "@/classes/axios.js";
const axios = new AxiosClass();

export const useEnumsStore = defineStore('enums', {
    state: () => ({
        Specializations: [],
        Languages: [],
        ConversationStatusTypes: [],
        ConnectionStatusTypes: [],
    }),
    actions: {
        async loadAllEnums() {
            await axios.get('allEnums').then((response) => {
                Object.keys(response).map(enumName => {
                    this[enumName] = Object.freeze(response[enumName]);
                });
            });
        },
        findInEnum(obj, searchKey, searchValue) {
            return (Object.entries(obj).find(([_, value]) => value[searchKey] === searchValue) || [])[1];
        },
        reloadEnums() {
            this.$reset();
            this.loadAllEnums();
        },
        clear() {
            this.$reset();
        },
    },
    persist: {
        storage: sessionStorage,
        paths: [
            'Specializations',
            'Languages',
            'ConversationStatusTypes',
            'ConnectionStatusTypes',
        ],
    },
});